import { request } from './http'
import type { BatchJobInput, BatchJobResponse, JobListResponse, JobStatus, JobView, SubmitJobInput, SubmitJobResponse } from '@/types/nf'

interface RawJobListResponse extends Omit<JobListResponse, 'items'> {
  items: JobView[] | null
}

export interface JobListOptions {
  branchId?: string
  status?: JobStatus
  limit?: number
  offset?: number
}

function buildJobListQuery(projectId: string, opts: JobListOptions = {}) {
  const qs = new URLSearchParams({ project_id: projectId })
  if (opts.branchId) qs.set('branch_id', opts.branchId)
  if (opts.status) qs.set('status', opts.status)
  if (opts.limit !== undefined) qs.set('limit', String(opts.limit))
  if (opts.offset !== undefined) qs.set('offset', String(opts.offset))
  return qs.toString()
}

export const jobApi = {
  list: async (projectId: string, opts?: JobListOptions): Promise<JobListResponse> => {
    const data = await request<RawJobListResponse>(`/v1/chapters/jobs?${buildJobListQuery(projectId, opts)}`)
    return { ...data, items: data.items ?? [] }
  },

  get: (id: string): Promise<JobView> => request<JobView>(`/v1/chapters/jobs/${encodeURIComponent(id)}`),

  submit: (body: SubmitJobInput): Promise<SubmitJobResponse> =>
    request<SubmitJobResponse>('/v1/chapters/jobs', { method: 'POST', body }),

  batch: (body: BatchJobInput): Promise<BatchJobResponse> =>
    request<BatchJobResponse>('/v1/chapters/jobs/batch', { method: 'POST', body }),
}
